"use client"
import { ThemeProvider, CssBaseline, Box } from "@mui/material"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Home from "./pages/Home"
import Profile from "./pages/Profile"
import DiscordCallback from "./pages/DiscordCallback"
import AuthLoading from "./pages/AuthLoading"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import TermsOfService from "./pages/TermsOfService"
import Contact from "./pages/Contact"
import Pricing from "./pages/Pricing"
import VPS from "./pages/VPS"
import Features from "./pages/Features"
import InRangePlayersPage from "./pages/InRangePlayersPage"
import { AuthProvider, useAuth } from "./context/AuthContext"
import { WebSocketProvider } from "./context/WebSocketContext"
import theme from "./theme"
import { ToastProvider } from "./context/ToastContext"
import { InRangePlayersProvider } from "./context/InRangePlayersContext"
import DiscordRequiredPageOverlay from "./pages/overlays/DiscordRequiredPageOverlay"
import SpaceBackground from "./components/SpaceBackground"

function AppRoutes() {
  const { loading } = useAuth()
  if (loading) {
    return <AuthLoading />
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <SpaceBackground />
      <Navbar />
      <Box
        sx={{
          flex: "1 0 auto",
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          px: 4,
          py: 8,
          position: "relative",
          zIndex: 1,
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/features" element={<Features />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/vps" element={<VPS />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/in-range-players" element={<DiscordRequiredPageOverlay content={<InRangePlayersPage />} />} />
          <Route path="/callback" element={<DiscordCallback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  )
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <InRangePlayersProvider>
          <AuthProvider>
            <WebSocketProvider>
              <Router>
                <AppRoutes />
              </Router>
            </WebSocketProvider>
          </AuthProvider>
        </InRangePlayersProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}

export default App
